export const GanttItemHeight = 86;
export const GanttItemInnerHeight = 38;